window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.moment = require('moment');
    require('bootstrap');
    //window.bsCustomFileInput = require('bs-custom-file-input');
    //require('shards-ui');
    //require('gijgo');
    require('pickadate/lib/compressed/picker')
    require('pickadate/lib/compressed/picker.date')
    require('pickadate/lib/compressed/picker.time')
    window.Swal = require('sweetalert2');
    require('select2');
    require('datatables.net-bs4');
    require('datatables.net-responsive-bs4');

    require('star-rating-svg/dist/jquery.star-rating-svg');
    require('smartbanner.js');
    //require('../../public/assets/site/js/jquery-steps/build/jquery.steps.js');
    require('../../public/assets/site/js/app-restaurant.js');
    require('slick-carousel');
    require('blockui');
    require('../../public/assets/site/js/helpers.js');
    require('../../public/assets/site/js/googleMaps.js');
    require('../../public/assets/site/js/picker.js');
    require('../../public/assets/site/js/booking.js');
    require('../../public/assets/site/js/cart.js');
    //require('../../public/assets/site/js/asap-restaurant.js');
    require('../../public/assets/site/js/home.js');
    require('../../public/assets/site/js/profile.js');
    require('../../public/assets/site/js/contact.js');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

/*window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

/*let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

/* import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '02124cf8c48951e2223a',
    cluster: 'eu',
    encrypted: true,
    forceTLS: true,
    authEndpoint: '/broadcasting/auth',
    
}); */